import React from "react"
import { Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer mt-4">
        <div className="container-fluid">
          <Row>
            <Col sm={6}>{new Date().getFullYear()} © SIS.</Col>
            <Col sm={6}>
              <div className="text-sm-end d-none d-sm-block">
                Conçu & Developpé par BM-SIS
              </div>
            </Col>
          </Row>
        </div>
      </footer>
    </React.Fragment>
  )
}

export default Footer
